import React from 'react';
import './Contact.css'; 
import Footer from './footer';

const Contact = () => {
  return (
    <><section className="con contact-page py-16">
      <div className="container mx-auto px-4 text-center">
        
        <h1 className="text-5xl font-bold text-dark-blue mb-8">Get in Touch with Guardians Home Care</h1>

        
        <div className="contact-details text-left md:text-center mb-12">
          <div className="contact-details flex flex-col md:flex-row justify-between items-start text-left md:text-center mb-12">
            <div className="w-full md:w-1/3 mb-4 md:mb-0">
              <p className="text-lg text-gray-700">
                <strong>Phone Number:</strong> For appointments, equipment rentals, or any inquiries, please call our reception at  <a href="tel:+91 9416129824" className="text-teal-600">[+91 9416129824]</a> <a href="tel:+91 9910967118" className="text-teal-600">[+91 9910967118]</a>.
              </p>
            </div>

        
            <div className="hidden md:block border-l-2 border-gray-300 h-full mx-4"></div>

            <div className="w-full md:w-1/3 mb-4 md:mb-0">
              <p className="text-lg text-gray-700">
                <strong>Office Address:</strong> Guardians Home Care, Dhannu Ram Hospital, Sector 2, BLB.
              </p>
            </div>

        
            <div className="hidden md:block border-l-2 border-gray-300 h-full mx-4"></div>

            <div className="w-full md:w-1/3">
              <p className="text-lg text-gray-700">
                <strong>WhatsApp Chat:</strong> Click below to chat directly with our team for immediate assistance.
              </p>
            </div>
          </div>

        
          <a
            href="https://wa.me/919910967118?text=Hello,%20I%20need%20assistance%20from%20Guardians%20Home%20Care."
            className="button-cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            Chat Now
          </a>
        </div>

        
        <div className="office-hours text-left md:text-center mt-12">
          <h3 className="text-3xl font-semibold text-dark-blue mb-4">Office Hours</h3>
          <ul className="text-lg text-gray-700">
            <li>Monday to Friday: 9 AM – 6 PM</li>
            <li>Saturday: 10 AM – 4 PM</li>
            <li>Sunday: Closed</li>
          </ul>
        </div>

        
        <div className="map mt-12">
          <iframe
            src="https://www.google.com/maps/embed?pb=[GoogleMapsEmbedLink]"
            width="100%"
            height="450"
            frameorder="0"
            style={{ border: 0 }}
            allowfullscreen=""
            aria-hidden="false"
            tabindex="0"
          ></iframe>
        </div>
      </div>
    </section><Footer /></>
  );
};

export default Contact;
